import { styled } from '@mui/material/styles'
import { Link } from 'react-router-dom'

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 'bold',
  textDecoration: 'none'
}))

export default StyledLink
